import { render, staticRenderFns } from "./ListChannels.vue?vue&type=template&id=df0f40e4&lang=pug"
import script from "./ListChannels.vue?vue&type=script&lang=js"
export * from "./ListChannels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df0f40e4')) {
      api.createRecord('df0f40e4', component.options)
    } else {
      api.reload('df0f40e4', component.options)
    }
    module.hot.accept("./ListChannels.vue?vue&type=template&id=df0f40e4&lang=pug", function () {
      api.rerender('df0f40e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/channels/ListChannels.vue"
export default component.exports